// extracted by mini-css-extract-plugin
export default {"copilotBadge":"CopilotBadgeV2-module__copilotBadge--OJjfk","loading":"CopilotBadgeV2-module__loading--NG3DO"};